import { toast } from "react-toastify";
import { HTTPURL } from "../../constants/Matcher";

// Update the signed-in branch user's email.
// payload: { current_email, current_password, new_email }
export async function branch_update_email(payload) {
  try {
    const response = await fetch(HTTPURL + "api/branches/update-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (error) {
    console.log(error.message);
    return { status: false, message: error.message };
  }
}

// Update the signed-in branch user's password.
// payload: { current_email, current_password, new_password }
export async function branch_update_password(payload) {
  try {
    const response = await fetch(HTTPURL + "api/branches/update-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (error) {
    console.log(error.message);
    return { status: false, message: error.message };
  }
}
